import { ShippingProviders } from './providers';

export interface ProviderServiceOption {
  code: string;
  name: string;
  isInternational?: boolean;
  isGreen?: boolean;
}

export interface ProviderServices {
  provider: ShippingProviders;
  servicesAvailable: ProviderServiceOption[];
}

export const PROVIDER_SERVICES: ProviderServices[] = [
  {
    provider: ShippingProviders.GLS,
    servicesAvailable: [{ code: 'GRD-NEG', name: 'GLS Parcel Ground' }],
  },
  {
    provider: ShippingProviders.CANADA_POST,
    servicesAvailable: [
      { code: 'DOM.EP', name: 'Canada Post Expedited Parcel' },
      { code: 'DOM.EP.EPLUS', name: 'Canada Post Expedited Parcel Plus' },
      { code: 'DOM.LIB', name: 'Canada Post Library Materials' },
      { code: 'DOM.PC', name: 'Canada Post Priority' },
      { code: 'DOM.RP', name: 'Canada Post Regular Parcel' },
      { code: 'DOM.XP', name: 'Canada Post Xpresspost' },
      { code: 'DOM.XP.CERT', name: 'Canada Post Xpresspost Certified' },
      { code: 'INT.IP.SURF', name: 'Canada Post International Parcel Surface', isInternational: true },
      { code: 'INT.IP.AIR', name: 'Canada Post International Parcel Air', isInternational: true },
      { code: 'INT.XP', name: 'Canada Post Xpresspost International', isInternational: true },
      { code: 'INT.TP', name: 'Canada Post Tracked Packet International', isInternational: true },
      { code: 'INT.SP.AIR', name: 'Canada Post Small Packet International Air', isInternational: true },
      { code: 'INT.SP.SURF', name: 'Canada Post Small Packet International Surface', isInternational: true },
      { code: 'USA.EP', name: 'Canada Post Expedited Parcel USA', isInternational: true },
      { code: 'USA.XP', name: 'Canada Post Xpresspost USA', isInternational: true },
      { code: 'USA.SP.AIR', name: 'Canada Post Small Packet USA Air', isInternational: true },
      { code: 'USA.TP', name: 'Canada Post Tracked Packet USA', isInternational: true },
    ],
  },
  {
    provider: ShippingProviders.CANADA_POST_3PL,
    servicesAvailable: [{ code: 'DOM.EP', name: 'Canada Post 3PL Expedited Parcel' }],
  },
  {
    provider: ShippingProviders.CANPAR,
    servicesAvailable: [
      { code: 'MACHOOL_CANPAR-GROUND', name: 'Canpar Ground' },
      { code: 'MACHOOL_CANPAR-GROUND-SELECT_LETTER', name: 'Canpar Ground Select Letter' },
      { code: 'MACHOOL_CANPAR-GROUND-SELECT_PARCEL', name: 'Canpar Ground Select Parcel' },
      { code: 'MACHOOL_CANPAR-GROUND-EXPRESS_LETTER', name: 'Canpar Ground Express Letter' },
      { code: 'MACHOOL_CANPAR-EXPRESS_PAK', name: 'Canpar Ground Express Pak' },
      { code: 'MACHOOL_CANPAR-GROUND-EXPRESS_PARCEL', name: 'Canpar Ground Express Parcel' },
      { code: 'MACHOOL_CANPAR-GROUND-BEFORE_NOON', name: 'Canpar Ground Before Noon' },
      { code: 'MACHOOL_CANPAR-GROUND-BEFORE_10_AM', name: 'Canpar Ground Before 10AM' },
      { code: 'MACHOOL_CANPAR-GROUND-SATURDAY', name: 'Canpar Ground Saturday' },
    ],
  },
  {
    provider: ShippingProviders.CHASSEURS_COURRIER,
    servicesAvailable: [
      { code: '1303', name: 'Chasseurs Courrier Same Day', isGreen: true },
      { code: '1380', name: 'Chasseurs Courrier Next Day', isGreen: true },
      { code: '393', name: 'Chasseurs Courrier Rush', isGreen: true },
    ],
  },
  {
    provider: ShippingProviders.FEDEX,
    servicesAvailable: [
      { code: 'PRIORITY_OVERNIGHT', name: 'FedEx Priority Overnight®' },
      { code: 'PRIORITY_OVERNIGHT_SATURDAY_DELIVERY', name: 'FedEx Priority Overnight® Saturday Delivery' },
      { code: 'FIRST_OVERNIGHT', name: 'FedEx First Overnight®' },
      { code: 'FIRST_OVERNIGHT_SATURDAY_DELIVERY', name: 'FedEx First Overnight® Saturday Delivery' },
      { code: 'FEDEX_EXPRESS_SAVER', name: 'FedEx Economy®' },
      { code: 'FEDEX_2_DAY', name: 'FedEx 2Day®' },
      { code: 'FEDEX_2_DAY_AM', name: 'FedEx 2Day® A.M.' },
      { code: 'FEDEX_2_DAY_SATURDAY_DELIVERY', name: 'FedEx 2Day® Saturday Delivery' },
      { code: 'STANDARD_OVERNIGHT', name: 'FedEx Standard Overnight™' },
      { code: 'FEDEX_GROUND', name: 'FedEx Ground®' },
      { code: 'GROUND_HOME_DELIVERY', name: 'FedEx Ground® Home Delivery' },
      { code: 'INTERNATIONAL_PRIORITY', name: 'FedEx International Priority®', isInternational: true },
      {
        code: 'INTERNATIONAL_PRIORITY_SATURDAY_DELIVERY',
        name: 'FedEx International Priority® Saturday Delivery',
        isInternational: true,
      },
      { code: 'INTERNATIONAL_ECONOMY', name: 'FedEx International Economy®', isInternational: true },
      { code: 'INTERNATIONAL_FIRST', name: 'FedEx International First®', isInternational: true },
      { code: 'FEDEX_GROUND', name: 'FedEx International Ground®', isInternational: true },
    ],
  },
  {
    provider: ShippingProviders.PUROLATOR,
    servicesAvailable: [
      { code: 'PurolatorExpress', name: 'Purolator Express®' },
      { code: 'PurolatorExpress9AM', name: 'Purolator Express® 9AM' },
      { code: 'PurolatorExpress10:30AM', name: 'Purolator Express® 10:30AM' },
      { code: 'PurolatorExpress12PM', name: 'Purolator Express® 12PM' },
      { code: 'PurolatorExpressEvening', name: 'Purolator Express® Evening' },
      { code: 'PurolatorGround', name: 'Purolator Ground®' },
      { code: 'PurolatorGround9AM', name: 'Purolator Ground® 9AM' },
      { code: 'PurolatorGround10:30AM', name: 'Purolator Ground® 10:30AM' },
      { code: 'PurolatorGroundEvening', name: 'Purolator Ground® Evening' },
      { code: 'PurolatorQuickShip', name: 'Purolator QuickShip®' },
      { code: 'PurolatorExpressU.S.', name: 'Purolator Express® U.S.', isInternational: true },
      { code: 'PurolatorExpressU.S.9AM', name: 'Purolator Express® U.S. 9AM', isInternational: true },
      { code: 'PurolatorExpressU.S.10:30AM', name: 'Purolator Express® U.S. 10:30AM', isInternational: true },
      { code: 'PurolatorExpressU.S.12PM', name: 'Purolator Express® U.S. 12PM', isInternational: true },
      { code: 'PurolatorGroundU.S.', name: 'Purolator Ground® U.S.', isInternational: true },
      { code: 'PurolatorExpressInternational', name: 'Purolator Express® International', isInternational: true },
      {
        code: 'PurolatorExpressInternational9AM',
        name: 'Purolator Express® International 9AM',
        isInternational: true,
      },
      {
        code: 'PurolatorExpressInternational10:30AM',
        name: 'Purolator Express® International 10:30AM',
        isInternational: true,
      },
      {
        code: 'PurolatorExpressInternational12:00',
        name: 'Purolator Express® International 12PM',
        isInternational: true,
      },
    ],
  },
  {
    provider: ShippingProviders.FREIGHT_PUROLATOR,
    servicesAvailable: [
      {
        code: 'PUROLATOR_FREIGHT_EXPEDITED',
        name: 'Purolator Freight Expedited',
      },
    ],
  },
  {
    provider: ShippingProviders.DHL,
    servicesAvailable: [
      { code: 'Y', name: 'DHL Express 12:00', isInternational: true },
      { code: 'P', name: 'DHL Express Worldwide', isInternational: true },
      { code: 'H', name: 'DHL Economy Select', isInternational: true },
      { code: 'E', name: 'DHL Express 09:00', isInternational: true },
      { code: 'D', name: 'DHL Express Worldwide Documents', isInternational: true },
    ],
  },
  {
    provider: ShippingProviders.NATIONEX,
    servicesAvailable: [
      { code: 'NATIONEX_STANDARD', name: 'Nationex' },
      { code: 'NATIONEX_GREEN', name: 'Nationex Green', isGreen: true },
    ],
  },
  {
    provider: ShippingProviders.RIVO,
    servicesAvailable: [
      { code: 'AC_UN', name: 'MultiLeg (AC -> UniUni)' },
      { code: 'AC_IC', name: 'MultiLeg (AC -> Intelcom | Dragonfly)' },
      { code: 'AC_CP', name: 'MultiLeg (AC -> Canada Post)' },
      { code: 'AC_SP', name: 'MultiLeg (AC -> Spring)', isInternational: true },
    ],
  },
  {
    provider: ShippingProviders.MULTILEG,
    servicesAvailable: [
      { code: 'AC_UN', name: 'MultiLeg (AC -> UniUni)' },
      { code: 'AC_CP', name: 'MultiLeg (AC -> Canada Post)' },
      { code: 'AC_TF', name: 'MultiLeg (AC -> TForce)' },
      { code: 'AC_AP', name: 'MultiLeg (AC -> Apple Express)' },
    ],
  },
  {
    provider: ShippingProviders.UPS,
    servicesAvailable: [
      { code: '11', name: 'UPS Standard®' },
      { code: '14', name: 'UPS Express® Early' },
      { code: '01', name: 'UPS Express®' },
      { code: '13', name: 'UPS Express Saver®' },
      { code: '02', name: 'UPS Expedited®' },
      { code: '11', name: 'UPS Standard®', isInternational: true },
      { code: '14', name: 'UPS Next Day Air Early A.M.', isInternational: true },
      { code: '07', name: 'UPS Express®', isInternational: true },
      { code: '65', name: 'UPS Express Saver®', isInternational: true },
      { code: '08', name: 'UPS Expedited®', isInternational: true },
      { code: '12', name: 'UPS 3 Day Select®', isInternational: true },
      { code: '54', name: 'UPS Worldwide Express Plus™', isInternational: true },
      { code: '07', name: 'UPS Worldwide Express®', isInternational: true },
      { code: '65', name: 'UPS Worldwide Express Saver®', isInternational: true },
      { code: '08', name: 'UPS Worldwide Expedited™', isInternational: true },
    ],
  },
  {
    provider: ShippingProviders.INTELCOM,
    servicesAvailable: [{ code: 'INTELCOM_STANDARD', name: 'Intelcom | Dragonfly Standard' }],
  },
  {
    provider: ShippingProviders.UNIUNI,
    servicesAvailable: [{ code: 'UNIUNI_STANDARD', name: 'Uniuni Standard' }],
  },
  {
    provider: ShippingProviders.FLASHBOX,
    servicesAvailable: [{ code: 'MACHOOL_FLASHBOX_SAME', name: 'FlashBox Same-Day' }],
  },
  {
    provider: ShippingProviders.SPRING,
    servicesAvailable: [
      { code: 'parcel-select', name: 'Parcel Select', isInternational: true },
      { code: 'packet-select', name: 'Packet Select', isInternational: true },
      { code: 'spring-gateway-parcel', name: 'Spring Gateway Parcel', isInternational: true },
      { code: 'spring-direct', name: 'Spring Direct', isInternational: true },
      { code: 'spring-direct-standard', name: 'Spring Direct Standard', isInternational: true },
      { code: 'spring-packet-tracked', name: 'Spring Packet Tracked', isInternational: true },
      { code: 'spring-packet-untracked', name: 'Spring Packet Untracked', isInternational: true },
    ],
  },
  {
    provider: ShippingProviders.TREXITY,
    servicesAvailable: [
      { code: 'default', name: 'Trexity Same-Day' },
      { code: 'nextday', name: 'Trexity Next-Day' },
    ],
  },
  {
    provider: ShippingProviders.LIVRAPIDE,
    servicesAvailable: [{ code: 'REG', name: 'Livrapide Regular' }],
  },
  {
    provider: ShippingProviders.ICS_COURIER,
    servicesAvailable: [
      { code: 'ND', name: 'ICS Next Day' },
      { code: 'GR', name: 'ICS Ground' },
    ],
  },
  {
    provider: ShippingProviders.DELIVRO,
    servicesAvailable: [
      { code: 'LD', name: 'Delivro Next Day' },
      { code: 'MJ', name: 'Delivro Same Day' },
    ],
  },
  {
    provider: ShippingProviders.LOOMIS_EXPRESS,
    servicesAvailable: [
      { code: 'DD', name: 'Loomis Ground' },
      { code: 'DE', name: 'Loomis Express 18:00' },
      { code: 'DN', name: 'Loomis Express 12:00' },
      { code: 'D9', name: 'Loomis Express 9:00' },
    ],
  },
  {
    provider: ShippingProviders.DEELEEO,
    servicesAvailable: [{ code: 'DEELEEO', name: 'Deeleeo' }],
  },
  {
    provider: ShippingProviders.CHRONO_EXPRESS,
    servicesAvailable: [{ code: '24H', name: 'ChronoExpress Next Day' }],
  },
  {
    provider: ShippingProviders.ZIPPLY,
    servicesAvailable: [
      { code: 'Same-Day', name: 'Zipply Same Day' },
      { code: 'Standard', name: 'Zipply Standard' },
      { code: 'Next-Day', name: 'Zipply Next Day' },
    ],
  },
  {
    provider: ShippingProviders.UBER,
    servicesAvailable: [{ code: 'MACHOOL_UBER', name: 'Uber' }],
  },
];
